// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__17l1T","sidebarTitle":"Sidebar_sidebarTitle__3_u3-","sidebarList":"Sidebar_sidebarList__1NnJ-"};